import api from "./api";
const setLocalState = (name, value) => {
  localStorage.setItem("@DommusCRM-" + name, value);
};
const getLocalState = (name) => {
  const value = localStorage.getItem("@DommusCRM-" + name);
  // if (!value) console.log(name + "<<<");
  return value;
};
const guService = {
  buscarAmbientes: () => {
    return api.get("/clientes/modulo/1");
  },
  loginGU: (token) => {
    return api.get(`/gu-api/login/${token}`);
  },
  validaToken: (token) => {
    return api.post("/gu-api/valida-token", { token });
  },

  logout: () => {
    localStorage.clear();
    if (window.location.pathname !== "/login") {
      window.location = process.env.REACT_APP_GU_FRONT + "/modulo/logout";
    }
  },

  redirectGU: () => {
    guService.logout()
    window.location = process.env.REACT_APP_GU_FRONT;
  },
  setLocalState,
  getLocalState,

  setLoginInfo: (data) => {
    setLocalState("token", data.access_token);
    setLocalState("nomeUsuario", data.nome_usuario);
    setLocalState("idUsuario", data.id_usuario);
    setLocalState("tipoUsuario", data.id_usuario_tipo);
    setLocalState("permissoes", data.permissoes);
    setLocalState("linkVendas", data.link_vendas);
    setLocalState("idInquilino", data.id_cliente);
    setLocalState("slug", data.slug);
    let retorno = data.modulos;
    let modulos = [];
    retorno.forEach((element) => {
      modulos.push(element.id_modulo);
    });
    setLocalState("modulos", JSON.stringify(modulos));
  },
  tiposUsuarios: {
    'Administrador do Sistema': 1,
    'Gestor Geral': 2,
    'Gestor Comercial': 3,
    'Backoffice Administrativo': 4,
    'Gestor Coban': 5,
    'Operador Coban': 6,
    'Gerente de Vendas': 7,
    'Corretor': 8,
    'Gestor de Rede PDV': 9,
    'Coordenador de Equipe PDV': 10,
    'Gestor Despachante': 11,
    'Operador Despachante': 12,
    'Relacionamento com o Cliente': 13,
    'Gestor de Vistoria': 14,
    'Vistoriador': 15,
    'Espelho de Vendas': 16,
    'Gestor de Pré Atendimento': 17,
    'Operador de Pré Atendimento': 18
  },
  buscarUrlTelaAditivo: (idProcesso, idAditivo=null) => {
    const uriVendas = encodeURIComponent(`index_ui.php?mgr=MQ==&ui=NTQ=&id_processo=${idProcesso}&tab=tabs-aditivos-tab`)
    const url = `/login/modulo/2?gu_token=${getLocalState('guToken')}&recurso=${uriVendas}`

    return api.get(`${url}&${idAditivo && `&id_aditivo=${idAditivo}` || '&novo_aditivo=true'}`)
  }
};

export default guService;
